import { observer } from 'mobx-react';
import { emptyFragment } from '../../../EmptyFragment';
import { SearchParameter, SearchParameters } from '../../../ListFilter/Types';
import { LicenseFamily } from '../../../Organization/Types';
import { ParticipantsOptionsResource } from '../../../ParticipantsStore/Options/Types';
import GenericSortFilter from '../../GenericSortFilter';

interface Props {
  licenseFamily: LicenseFamily;
  searchParameters: SearchParameters;
  updatingSearchParameters: (searchParameter: SearchParameter) => void;
  participantsOptionsResource: ParticipantsOptionsResource;
}

function LimaFilters({
  searchParameters,
  updatingSearchParameters,
  licenseFamily,
  participantsOptionsResource,
}: Props) {
  switch (licenseFamily) {
    case 'lima':
      return (
        <>
          <div className="mr-4 w-2/6">
            <GenericSortFilter
              labelText="License"
              options={participantsOptionsResource.payload.licenses}
              parameters={searchParameters}
              updatingParameters={updatingSearchParameters}
              sortFilterKey={'license_id'}
            />
          </div>
          <div className="mr-4 w-2/6">
            <GenericSortFilter
              labelText="License Type"
              options={participantsOptionsResource.payload.licenseTypes}
              parameters={searchParameters}
              updatingParameters={updatingSearchParameters}
              sortFilterKey={'license_type'}
            />
          </div>
          <div className="mr-4 w-2/6">
            <GenericSortFilter
              labelText="License Started Date"
              options={participantsOptionsResource.payload.licenseStartDates}
              parameters={searchParameters}
              updatingParameters={updatingSearchParameters}
              sortFilterKey={'license_started_date'}
            />
          </div>
          <div className="mr-4 w-2/6">
            <GenericSortFilter
              labelText="License Status"
              options={participantsOptionsResource.payload.licenseStatuses}
              parameters={searchParameters}
              updatingParameters={updatingSearchParameters}
              sortFilterKey={'license_status'}
            />
          </div>
        </>
      );
    case 'classic':
      return emptyFragment();
  }
}

export default observer(LimaFilters);
